import * as React from 'react';
import { motion } from 'framer-motion';
import { Logo } from 'components/global';
import { useForceLanguage } from 'hooks/use-force-language';
import { DEFAULT_LANGUAGE } from 'i18n';
import { AuthBackground } from './AuthBackground';
import { cn } from 'lib/utils';

interface AuthLayoutProps {
  children: React.ReactNode;
  /** Width constraint for the form column. */
  contentClassName?: string;
}

/** Background + brand mark; individual pages only describe their own box. */
export const AuthLayout: React.FC<AuthLayoutProps> = ({ children, contentClassName }) => {
  // Auth surfaces are always presented in Uzbek; the user's saved app language
  // is restored once they leave the auth flow.
  useForceLanguage(DEFAULT_LANGUAGE);

  return (
    <div className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-background px-5 py-10 text-foreground sm:px-8">
      <AuthBackground />

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
        className={cn('relative z-10 w-full max-w-md', contentClassName)}
      >
        <div className="mb-8">
          <Logo width={32} height={32} />
        </div>
        {children}
      </motion.div>
    </div>
  );
};

AuthLayout.displayName = 'AuthLayout';
